import React, { useContext } from 'react';
import Navbar from './components/NavBar';
import AlbumList from './components/AlbumList';
import GalleryPage from './components/GalleryPage';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import UpdateProfile from './components/UpdateProfile';
import { AuthContext } from './context/AuthContext';

const App = () => {

    const  { currentUser } = useContext(AuthContext);

    return (
        
        
        <div>
            
            <Router>
            <Navbar/>
            <Switch>
                <PrivateRoute exact path="/" component={AlbumList} />
                <Route path = {`/albums/:albumId`} component={GalleryPage} />
                <Route path ="/signup" component={Signup} />
                <Route path = "/login" component={Login} />
                <Route path = "/forgot-password" component={ForgotPassword} />
                <Route path = "/update-profile" component={UpdateProfile} />
            </Switch>
            </Router>
        </div>
     );
}
 
export default App;